// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ScannerSettingsPage.module.css */

.ScannerSettingsPage_container__xEBft {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 12px;
  box-sizing: border-box;
  background-color: #f9f9f9;
  overflow-y: auto;
  position: relative;
}

.ScannerSettingsPage_settingItem__ZZYKl {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;     /* уменьшили отступ */
}

.ScannerSettingsPage_label__zg8GJ {
  font-size: 0.95rem;      /* чуть меньше шрифт */
  color: #333;
  flex: 1 1;
}

/* Радиогруппа: разрешаем перенос на новые строки */
.ScannerSettingsPage_radioGroup__W6rlf {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;                /* чуть меньше расстояние */
}

.ScannerSettingsPage_radioOption__OXdy4 {
  position: relative;
}

.ScannerSettingsPage_radioOption__OXdy4 input[type="radio"] {
  opacity: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.ScannerSettingsPage_radioText__\\+aT7j {
  display: inline-block;
  padding: 6px 12px;       /* поменьше padding */
  border: 2px solid #ccc;
  border-radius: 16px;     /* чуть меньше скругление */
  font-size: 0.85rem;      /* уменьшили шрифт */
  color: #333;
  transition: all 0.2s;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.ScannerSettingsPage_radioOption__OXdy4 input:checked + .ScannerSettingsPage_radioText__\\+aT7j {
  border-color: #007bff;
  background-color: #e6f0ff;
  color: #007bff;
}

/* Toggle Switch */
.ScannerSettingsPage_toggleSwitch__rftXj {
  position: relative;
  width: 44px;             /* немного уже */
  height: 24px;            /* чуть ниже */
  flex-shrink: 0;
}

.ScannerSettingsPage_toggleSwitch__rftXj input {
  opacity: 0;
  width: 0;
  height: 0;
}

.ScannerSettingsPage_slider__p7-5C {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 24px;
}

.ScannerSettingsPage_slider__p7-5C:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

.ScannerSettingsPage_toggleSwitch__rftXj input:checked + .ScannerSettingsPage_slider__p7-5C {
  background-color: #007bff;
}

.ScannerSettingsPage_toggleSwitch__rftXj input:checked + .ScannerSettingsPage_slider__p7-5C:before {
  transform: translateX(20px);
}

/* Кнопка назад: приклеим к низу страницы, но в более компактной форме */
.ScannerSettingsPage_backButton__\\+\\+Qf\\+ {
  position: absolute;
  bottom: 70px;
  width: 70%;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgb(0, 123, 255);
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.ScannerSettingsPage_backButton__\\+\\+Qf\\+:hover {
  background-color: rgb(0, 105, 217);
}

`, "",{"version":3,"sources":["webpack://./src/modules/Courier/CourierModal/styles/ScannerSettingsPage.module.css"],"names":[],"mappings":"AAAA,mCAAmC;;AAEnC;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB,MAAM,qBAAqB;AAChD;;AAEA;EACE,kBAAkB,OAAO,sBAAsB;EAC/C,WAAW;EACX,SAAO;AACT;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,eAAe;EACf,QAAQ,iBAAiB,2BAA2B;AACtD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB,QAAQ,qBAAqB;EAC9C,sBAAsB;EACtB,mBAAmB,MAAM,2BAA2B;EACpD,kBAAkB,OAAO,oBAAoB;EAC7C,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,WAAW,cAAc,gBAAgB;EACzC,YAAY,aAAa,cAAc;EACvC,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,wEAAwE;AACxE;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,kCAAkC;EAClC,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":["/* ScannerSettingsPage.module.css */\r\n\r\n.container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  padding: 12px;\r\n  box-sizing: border-box;\r\n  background-color: #f9f9f9;\r\n  overflow-y: auto;\r\n  position: relative;\r\n}\r\n\r\n.settingItem {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 16px;     /* уменьшили отступ */\r\n}\r\n\r\n.label {\r\n  font-size: 0.95rem;      /* чуть меньше шрифт */\r\n  color: #333;\r\n  flex: 1;\r\n}\r\n\r\n/* Радиогруппа: разрешаем перенос на новые строки */\r\n.radioGroup {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 8px;                /* чуть меньше расстояние */\r\n}\r\n\r\n.radioOption {\r\n  position: relative;\r\n}\r\n\r\n.radioOption input[type=\"radio\"] {\r\n  opacity: 0;\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 100%;\r\n  cursor: pointer;\r\n}\r\n\r\n.radioText {\r\n  display: inline-block;\r\n  padding: 6px 12px;       /* поменьше padding */\r\n  border: 2px solid #ccc;\r\n  border-radius: 16px;     /* чуть меньше скругление */\r\n  font-size: 0.85rem;      /* уменьшили шрифт */\r\n  color: #333;\r\n  transition: all 0.2s;\r\n  cursor: pointer;\r\n  user-select: none;\r\n}\r\n\r\n.radioOption input:checked + .radioText {\r\n  border-color: #007bff;\r\n  background-color: #e6f0ff;\r\n  color: #007bff;\r\n}\r\n\r\n/* Toggle Switch */\r\n.toggleSwitch {\r\n  position: relative;\r\n  width: 44px;             /* немного уже */\r\n  height: 24px;            /* чуть ниже */\r\n  flex-shrink: 0;\r\n}\r\n\r\n.toggleSwitch input {\r\n  opacity: 0;\r\n  width: 0;\r\n  height: 0;\r\n}\r\n\r\n.slider {\r\n  position: absolute;\r\n  cursor: pointer;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: #ccc;\r\n  transition: 0.4s;\r\n  border-radius: 24px;\r\n}\r\n\r\n.slider:before {\r\n  position: absolute;\r\n  content: \"\";\r\n  height: 20px;\r\n  width: 20px;\r\n  left: 2px;\r\n  bottom: 2px;\r\n  background-color: white;\r\n  transition: 0.4s;\r\n  border-radius: 50%;\r\n}\r\n\r\n.toggleSwitch input:checked + .slider {\r\n  background-color: #007bff;\r\n}\r\n\r\n.toggleSwitch input:checked + .slider:before {\r\n  transform: translateX(20px);\r\n}\r\n\r\n/* Кнопка назад: приклеим к низу страницы, но в более компактной форме */\r\n.backButton {\r\n  position: absolute;\r\n  bottom: 70px;\r\n  width: 70%;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  background-color: rgb(0, 123, 255);\r\n  color: #fff;\r\n  border: none;\r\n  padding: 8px 16px;\r\n  border-radius: 4px;\r\n  font-size: 1rem;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.backButton:hover {\r\n  background-color: rgb(0, 105, 217);\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ScannerSettingsPage_container__xEBft`,
	"settingItem": `ScannerSettingsPage_settingItem__ZZYKl`,
	"label": `ScannerSettingsPage_label__zg8GJ`,
	"radioGroup": `ScannerSettingsPage_radioGroup__W6rlf`,
	"radioOption": `ScannerSettingsPage_radioOption__OXdy4`,
	"radioText": `ScannerSettingsPage_radioText__+aT7j`,
	"toggleSwitch": `ScannerSettingsPage_toggleSwitch__rftXj`,
	"slider": `ScannerSettingsPage_slider__p7-5C`,
	"backButton": `ScannerSettingsPage_backButton__++Qf+`
};
export default ___CSS_LOADER_EXPORT___;
